import { render, staticRenderFns } from "./SectionCodifications.vue?vue&type=template&id=c80639c4&"
import script from "./SectionCodifications.vue?vue&type=script&lang=js&"
export * from "./SectionCodifications.vue?vue&type=script&lang=js&"
import style0 from "./SectionCodifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports